module.exports = __webpack_public_path__ + "media/21.70adb35a.mp3";